import React, {useEffect, useMemo, useState} from 'react';

import {GoogleMap, InfoBox, Marker, Polyline, useJsApiLoader} from '@react-google-maps/api';

import CustomIconMarker from './pin-sebrae.svg';
import {cnpjMask} from "../../utils/mask";
import {formatDateToBR, formatHoursToBRWithoutSeconds} from "../../utils/time";

const MapComponent = ({ data, containerStyle = { width: '100%',  height: '100%', margin: '0 auto' }, zoom = 15 }) => {

    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBe5GWIF8Tn_-5THWx1StcfzTIwYEiNwFs"
    })

    const [distance, setDistance] = useState(0);

    const infoWindowStyle = {
        background: "white",
        border: "1px solid #ccc",
        padding: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        borderRadius: '4px'
    };

    const {geolocalizacao: geolocalizacaoAtendimento, geolocalizacaoEmpresa} = data?.apr;
    const {empreendedor} = data;

    const posicaoAtendimento = useMemo(() => {
        if (geolocalizacaoAtendimento) {
            return { lat: geolocalizacaoAtendimento.latitude, lng: geolocalizacaoAtendimento.longitude };
        }
        return { lat: null, lng: null };
    }, [geolocalizacaoAtendimento]);

    const posicaoEmpresa = useMemo(() => {
        if (geolocalizacaoEmpresa) {
            return { lat: geolocalizacaoEmpresa.latitude, lng: geolocalizacaoEmpresa.longitude };
        }
        return { lat: null, lng: null };
    }, [geolocalizacaoEmpresa]);

    const calculateDistanceInMeters = () => {
        const R = 6371 * 1000; // Raio médio da Terra em metros
        const lat1 = posicaoAtendimento.lat;
        const long1 = posicaoAtendimento.lng;

        const lat2 = posicaoEmpresa.lat;
        const long2 = posicaoEmpresa.lng;

        const lat1Rad = (lat1 * Math.PI) / 180;
        const lat2Rad = (lat2 * Math.PI) / 180;
        const deltaLat = ((lat2 - lat1) * Math.PI) / 180;
        const deltaLong = ((long2 - long1) * Math.PI) / 180;

        const a =
            Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
            Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(deltaLong / 2) * Math.sin(deltaLong / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distanceCalculated = R * c;
        setDistance(distanceCalculated);
    };

    useEffect(() => {
        if (posicaoEmpresa.lat && posicaoEmpresa.lng) {
            calculateDistanceInMeters();
        }
        // eslint-disable-next-line
    }, [posicaoEmpresa]);

    if (!geolocalizacaoEmpresa || !geolocalizacaoEmpresa.latitude) {
        return null;
    }

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={posicaoEmpresa}
            zoom={zoom}
        >

            <Marker position={posicaoEmpresa} icon={CustomIconMarker}/>
            {
                distance > 300 &&
                <>
                    <Marker position={posicaoAtendimento} />
                    <InfoBox position={posicaoAtendimento}>
                        <div style={infoWindowStyle}>
                            <h3>Atendente: {data.nomeAtendente}</h3>
                            <p>Data Atendimento: {formatDateToBR(data.apr.inicioAtendimento)}</p>
                            <p>Horário Início: {formatHoursToBRWithoutSeconds(data.apr.inicioAtendimento)}</p>
                            <p>Horário Fim: {formatHoursToBRWithoutSeconds(data.apr.fimAtendimento)}</p>
                        </div>
                    </InfoBox>

                    <Polyline
                        path={[posicaoAtendimento, posicaoEmpresa]}
                        options={{
                            strokeColor: '#1c1b1b',
                            strokeOpacity: .9,
                            strokeWeight: 1,
                        }}
                    />
                </>
            }

            {
                !!distance &&
                <div
                    style={{
                        position: 'absolute',
                        bottom: '20px',
                        left: '20px', // Ajuste a posição horizontal conforme necessário
                        backgroundColor: 'white',
                        padding: '8px',
                        borderRadius: '4px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    Distância entre Empresa e Agente: {distance.toFixed(2)} metros
                </div>

            }

            <InfoBox  position={posicaoEmpresa}>
                <div style={infoWindowStyle}>
                    <h3>{empreendedor.nomeFantasia}</h3>
                    <p>CNPJ: {cnpjMask(empreendedor.cnpj)}</p>
                    <p>UF: {empreendedor.uf}</p>
                    {
                        distance < 300 && (
                            <>
                                <p>Atendente: {data.nomeAtendente}</p>
                                <p>Data Atendimento: {formatDateToBR(data.apr.inicioAtendimento)}</p>
                                <p>Horário Início: {formatHoursToBRWithoutSeconds(data.apr.inicioAtendimento)}</p>
                                <p>Horário Fim: {formatHoursToBRWithoutSeconds(data.apr.fimAtendimento)}</p>
                            </>
                        )
                    }
                </div>
            </InfoBox>
        </GoogleMap>
    ) : <>
    </>
}

export default React.memo(MapComponent);
